<script setup lang="ts">
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
</script>

<template>
  <TooltipProvider>
    <NuxtLayout>
      <NuxtPage />
      <Toaster />
    </NuxtLayout>
    <VueQueryDevtools />
  </TooltipProvider>
</template>

<style>
html,
body {
  font-family: "Inter", sans-serif;
  font-size: 16px;
}
</style>
